import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {DateConversionPipe} from '../../pipes/date-conversion.pipe';
import {IncidentsService} from '../../services/incidents.service';
import {NgxSpinnerModule, NgxSpinnerService} from 'ngx-spinner';
import {NgbModal, NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {DurationPipe} from '../../pipes/duration.pipe';
import {DecimalPipe} from '@angular/common';
import {environment} from 'src/environments/environment';
import {PaginatedIncidentComponentBase} from '../../shared/paginated-incident.component';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-smoke-incident',
  templateUrl: './smoke-incident.component.html',
  standalone: true,
  imports: [
    TranslatePipe,
    DateConversionPipe,
    NgxSpinnerModule,
    NgbModalModule,
    DurationPipe,
    DecimalPipe
  ],
  styleUrl: './smoke-incident.component.scss'
})
export class SmokeIncidentComponent extends PaginatedIncidentComponentBase<any, any> {
  smokeEvents: any;
  @Input() filter?: string;
  host: string = environment.host;

  constructor(incidentService: IncidentsService,
              spinnerService: NgxSpinnerService,
              cdRef: ChangeDetectorRef,
              modalService: NgbModal) {
    super(incidentService, spinnerService, cdRef, modalService);
  }

  protected override get requiresAuthToken(): boolean {
    return true;
  }

  protected override get incidentPage(): any {
    return this.smokeEvents;
  }

  protected override set incidentPage(value: any) {
    this.smokeEvents = value;
  }

  protected override get filterValue(): string | undefined {
    return this.filter;
  }

  protected override fetchPage(licencePlate?: string, skip?: number, limit?: number): Observable<any> {
    return this.incidentService.getSmokeIncidents(licencePlate, skip, limit);
  }

}
